import get from 'lodash.get';

const getAssetsUrl = (state) => get(state, 'ws.site.session.assetsUrl', '');

export default getAssetsUrl;
